import type { PageNavigation } from 'navigation/types';

import * as urls from '../urls';

export const ABOUT_US_NAVIGATION: PageNavigation = {
  pageUrl: urls.getAboutUsUrl(),
  currentLink: { text: 'About Us', href: urls.getAboutUsUrl() },
  links: [
    {
      text: 'Our Brands',
      href: urls.getOurBrandsUrl(),
    },
    {
      text: 'Our History',
      href: urls.getHistoryUrl(),
    },
    {
      text: 'Our Management Team',
      href: urls.getManagementTeamUrl(),
    },
    {
      text: 'News and Updates',
      href: urls.getNewsUrl(),
    },
  ],
};
